import { Card, Checkbox, Form } from "antd";
import React, { useEffect, useState } from "react";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useForm } from "antd/lib/form/Form";
import { toast } from "react-hot-toast";

import FormAction from "../../../../components/common/FormAction";

function Status({ data }) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const [form] = useForm();

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const status = {
      tenantBalanceStatus: {
        balance: "",
        delinquencyNotes: "",
        evicting: values.evicting,
        lastReceipt: "",
        inCollections: values.inCollections,
        certifiedFundsOnly: values.certifiedFundsOnly,
        allowOnlinePayments: "",
        LastIncomeCertification: "",
        requireOnlinePaymentsInFull: values.requireOnlinePaymentsInFull,
        eligibleForRenewal: values.eligibleForRenewal,
      },
    };
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, status);
      setChecked(false);
      toast.success("Status updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    evicting: data?.status?.evicting,
    inCollections: data?.status?.inCollections,
    certifiedFundsOnly: data?.status?.certifiedFundsOnly,
    allowOnlinePayments: data?.status?.allowOnlinePayments,
    requireOnlinePaymentsInFull: data?.status?.requireOnlinePaymentsInFull,
    eligibleForRenewal: data?.status?.eligibleForRenewal,
  };
  return (
    <Card
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
      title="Status"
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 14 }}
          wrapperCol={{ span: 10 }}
          labelWrap={{ span: 14 }}
          initialValues={initialValues}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <Form.Item label="Balance">
            <span className="onclick-text">--</span>
          </Form.Item>
          <Form.Item label="Delinquency Notes">
            <span className="onclick-text">Add delinquency note</span>
          </Form.Item>
          <Form.Item label="Last Receipt">
            <span className="onclick-text">--</span>
          </Form.Item>
          <Form.Item label="Evicting" name="evicting" valuePropName="checked">
            <Checkbox></Checkbox>
          </Form.Item>
          <Form.Item
            label="In Collections"
            name="inCollections"
            valuePropName="checked"
          >
            <Checkbox></Checkbox>
          </Form.Item>
          <Form.Item
            label="Certified Funds Only"
            name="certifiedFundsOnly"
            valuePropName="checked"
          >
            <Checkbox></Checkbox>
          </Form.Item>
          <Form.Item
            label="Allow Online Payments"
            name="allowOnlinePayments"
            valuePropName="checked"
          >
            <Checkbox disabled></Checkbox>
          </Form.Item>
          <Form.Item label="Last Income Certification">
            <span></span>
          </Form.Item>
          <Form.Item label=" ">
            <span className="onclick-text">View all income certifications</span>
          </Form.Item>
          <Form.Item
            label="Require Online Payments In Full"
            name="requireOnlinePaymentsInFull"
            valuePropName="checked"
          >
            <Checkbox></Checkbox>
          </Form.Item>
          <Form.Item
            label="Eligible for Renewal"
            name="eligibleForRenewal"
            valuePropName="checked"
          >
            <Checkbox></Checkbox>
          </Form.Item>
          <FormAction cancel={onCancel} submit="submit" />
        </Form>
      ) : (
        <Form
          colon={false}
          labelCol={{ span: 14 }}
          wrapperCol={{ span: 10 }}
          labelWrap={{ span: 14 }}
        >
          <Form.Item label="Balance">
            <span className="onclick-text">$--</span>
          </Form.Item>
          <Form.Item label="Delinquency Notes">
            <span className="onclick-text">Add delinquency note</span>
          </Form.Item>
          <Form.Item label="Last Receipt">
            <span className="onclick-text">--</span>
          </Form.Item>
          <Form.Item label="Evicting">
            <span>{data?.tenantBalanceStatus?.evicting ? "Yes" : "No"}</span>
          </Form.Item>
          <Form.Item label="In Collections">
            <span>
              {data?.tenantBalanceStatus?.inCollections ? "Yes" : "No"}
            </span>
          </Form.Item>
          <Form.Item label="Certified Funds Only">
            <span>
              {data?.tenantBalanceStatus?.certifiedFundsOnly ? "Yes" : "No"}
            </span>
          </Form.Item>
          <Form.Item label="Allow Online Payments">
            <span>--</span>
          </Form.Item>
          <Form.Item label="Last Income Certification">
            <span>--</span>
          </Form.Item>
          <Form.Item label=" ">
            <span className="onclick-text">View all income certifications</span>
          </Form.Item>
          <Form.Item label="Require Online Payments In Full">
            <span>
              {data?.tenantBalanceStatus?.requireOnlinePaymentsInFull
                ? "Yes"
                : "No"}
            </span>
          </Form.Item>
          <Form.Item label="Eligible for Renewal">
            <span>
              {data?.tenantBalanceStatus?.eligibleForRenewal ? "Yes" : "No"}
            </span>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
}

export default Status;
